"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewLibrary = void 0;
const DataType_1 = __importDefault(require("@opsbase/lib-datatype/DataType"));
const AssetViews_1 = __importDefault(require("../views/AssetViews"));
const ConversationViews_1 = __importDefault(require("../views/ConversationViews"));
const IndustryViews_1 = __importDefault(require("../views/IndustryViews"));
const IssuesToDoViews_1 = __importDefault(require("../views/IssuesToDoViews"));
const IssueViews_1 = __importDefault(require("../views/IssueViews"));
const OpDefinitionViews_1 = __importDefault(require("../views/OpDefinitionViews"));
const OpsToDoViews_1 = __importDefault(require("../views/OpsToDoViews"));
const OpViews_1 = __importDefault(require("../views/OpViews"));
const OrganisationViews_1 = __importDefault(require("../views/OrganisationViews"));
const PlaceViews_1 = __importDefault(require("../views/PlaceViews"));
const PositionViews_1 = __importDefault(require("../views/PositionViews"));
const QuestionSetViews_1 = __importDefault(require("../views/QuestionSetViews"));
const StaffViews_1 = __importDefault(require("../views/StaffViews"));
const SuperUserViews_1 = __importDefault(require("../views/SuperUserViews"));
const TaskViews_1 = __importDefault(require("../views/TaskViews"));
const TeamboardViews_1 = __importDefault(require("../views/TeamboardViews"));
const TeamViews_1 = __importDefault(require("../views/TeamViews"));
const TemplateViews_1 = __importDefault(require("../views/TemplateViews"));
const WorkflowViews_1 = __importDefault(require("../views/WorkflowViews"));
const OrgTemplateViews_1 = __importDefault(require("../views/OrgTemplateViews"));
exports.ViewLibrary = {
    [DataType_1.default.ASSET]: AssetViews_1.default,
    [DataType_1.default.ISSUE]: IssueViews_1.default,
    [DataType_1.default.CONVERSATION]: ConversationViews_1.default,
    [DataType_1.default.OP]: OpViews_1.default,
    [DataType_1.default.OP_TODO]: OpsToDoViews_1.default,
    [DataType_1.default.ISSUE_TODO]: IssuesToDoViews_1.default,
    [DataType_1.default.OPDEFINITION]: OpDefinitionViews_1.default,
    [DataType_1.default.ORGANISATION]: OrganisationViews_1.default,
    [DataType_1.default.POSITION]: PositionViews_1.default,
    [DataType_1.default.STAFF]: StaffViews_1.default,
    [DataType_1.default.SUPERUSER]: SuperUserViews_1.default,
    [DataType_1.default.PLACE]: PlaceViews_1.default,
    [DataType_1.default.TEAMBOARD]: TeamboardViews_1.default,
    [DataType_1.default.TEAM]: TeamViews_1.default,
    [DataType_1.default.TASK]: TaskViews_1.default,
    [DataType_1.default.TEMPLATE]: TemplateViews_1.default,
    [DataType_1.default.INDUSTRY]: IndustryViews_1.default,
    [DataType_1.default.WORKFLOW]: WorkflowViews_1.default,
    [DataType_1.default.QUESTIONSET]: QuestionSetViews_1.default,
    [DataType_1.default.ORGTEMPLATE]: OrgTemplateViews_1.default,
};
exports.default = exports.ViewLibrary;
